// Filigree peony watermark using uploaded x-ray style peony images.
// Variant "1" → top-right, Variant "2" → bottom-left (mirrored).
export const FloralOrnament = ({ className = "", variant = "1", testId = "floral-ornament" }) => {
  const src = variant === "2" ? "/ornaments/pivoine-2.png" : "/ornaments/pivoine-1.png";
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className={className}
      data-testid={testId}
      loading="lazy"
    />
  );
};

export default FloralOrnament;
